// src/ApiPanel/pages/ca/InvoicePages.jsx
// The six invoice screens. Each is a thin configuration of InvoiceReport —
// the differences between them are genuinely only the endpoint and the
// wording, so that is all these files contain.
import React from "react";
import InvoiceReport from "../../components/reports/InvoiceReport";
import { API_PANEL_ENDPOINTS } from "../../constants/apiPanelAuth";

export function SellInvoiceDetails() {
  return (
    <InvoiceReport
      title="Sell Invoice Details"
      subtitle="Outward supplies you raised — service and convenience charges billed to partners, excluding recharge."
      endpoint={API_PANEL_ENDPOINTS.CA_SELL_INVOICE}
      exportName="sell_invoice"
    />
  );
}

export function SellCmsInvoiceDetails() {
  return (
    <InvoiceReport
      title="Sell CMS Invoice Details"
      subtitle="Outward supplies for CMS collections."
      endpoint={API_PANEL_ENDPOINTS.CA_SELL_CMS_INVOICE}
      exportName="sell_cms_invoice"
    />
  );
}

export function SellRechargeInvoiceDetails() {
  return (
    <InvoiceReport
      title="Sell Recharge Invoice Details"
      subtitle="Outward supplies for recharge and DTH."
      endpoint={API_PANEL_ENDPOINTS.CA_SELL_RECHARGE_INVOICE}
      exportName="sell_recharge_invoice"
    />
  );
}

export function PurchaseInvoiceDetails() {
  return (
    <InvoiceReport
      title="Purchase Invoice Details"
      subtitle="Inward supplies — commission billed to you by partners, and vendor invoices you have uploaded."
      endpoint={API_PANEL_ENDPOINTS.CA_PURCHASE_INVOICE}
      exportName="purchase_invoice"
    />
  );
}

export function PurchaseRechargeInvoiceDetails() {
  return (
    <InvoiceReport
      title="Purchase Recharge Invoice Details"
      subtitle="Inward supplies from recharge operators."
      endpoint={API_PANEL_ENDPOINTS.CA_PURCHASE_RECHARGE_INVOICE}
      exportName="purchase_recharge_invoice"
    />
  );
}

export function PurchaseUtilityInvoiceDetails() {
  return (
    <InvoiceReport
      title="Purchase Utility Invoice Details"
      subtitle="Inward supplies from utility and BBPS billers."
      endpoint={API_PANEL_ENDPOINTS.CA_PURCHASE_UTILITY_INVOICE}
      exportName="purchase_utility_invoice"
    />
  );
}
